import React, { ForwardedRef, useContext } from 'react';
import { OriginIconProps } from '../type';
import { Context } from '../context';

function IconTopComponent(props: OriginIconProps, ref: ForwardedRef<SVGSVGElement>) {
    const { prefix: prefixFromContext } = useContext(Context);
    const { className = '', prefix: prefixFromProps, width = '1em', height = '1em', useCurrentColor = true, spin, ...rest } = props;

    const prefix = prefixFromProps || prefixFromContext || 'alliance';
    const loadingKls = spin ? ` ${prefix}-icon-loading` : '';
    return <svg className={`${prefix}-icon ${prefix}-icon-Top${loadingKls} ${className}`} width={width} height={height} viewBox="0 0 16 16" fill={useCurrentColor ? 'currentColor' : '#000'} xmlns="http://www.w3.org/2000/svg" {...rest} ref={ref}><path d="M3.4 2.6a.667.667 0 000 1.333h9.216a.667.667 0 100-1.333H3.4zM8.474 4.744a.667.667 0 00-.942 0l-3.66 3.66a.667.667 0 00.942.943l2.543-2.543v6.13a.667.667 0 101.333 0V6.851l2.502 2.502a.667.667 0 10.942-.943L8.526 4.802a.673.673 0 00-.052-.058z"/></svg>;
}

const IconTop = React.forwardRef(IconTopComponent);
export default IconTop;
